// src/shared/changelog/components/MonthGroup.tsx
import React from "react";
import { ChangelogMonthGroup } from "../grouping";
import { formatReleasePeriod } from "../format";
import EntryCard from "./EntryCard";

interface MonthGroupProps {
  group: ChangelogMonthGroup;
  /** `entryKey` targeted by the URL hash, if any. */
  targetEntryKey?: string;
}

/**
 * A month of entries rendered as a timeline node: a marker on the rail, the
 * derived month heading, and the entries themselves.
 *
 * The heading is computed from the group's date — no one authors it, which is
 * the point of the flat model.
 */
const MonthGroup: React.FC<MonthGroupProps> = ({ group, targetEntryKey }) => {
  const period = formatReleasePeriod(group.date);

  return (
    <li className="relative pl-8" aria-label={period}>
      {/* Timeline marker on the rail */}
      <span
        className="
          absolute left-0 top-2 h-3 w-3 -translate-x-1/2 rounded-full
          border-2 border-semantic-bg-primary bg-semantic-bg-brand-bold
        "
        aria-hidden
      />

      <h2 className="mb-2 text-lg font-semibold text-semantic-text-primary">
        {period}
      </h2>

      <ul className="flex flex-col gap-3">
        {group.entries.map((entry) => (
          <EntryCard
            key={entry.entryKey}
            entry={entry}
            isTargeted={entry.entryKey === targetEntryKey}
          />
        ))}
      </ul>
    </li>
  );
};

export default MonthGroup;
